import React from 'react';
import Select from '../../../ui/Select';
import styles from './GoalFilter.module.css';

// Narrows the calendar to a single goal. It does not touch the indicator table
// (device data is not attached to a goal), and the day view ignores it — its
// timeline is the whole day across every goal — so the page hides it there.
//
// With eight goals a month is close to all fives, because a cell carries the
// highest rating across every goal in the day. Filtering is what makes it
// readable.
const GoalFilter = ({ goals = [], value, onChange }) => {
	// Goals only carry a goal_setting_id once they have been saved and re-read.
	const filterable = goals.filter((goal) => goal.goal_setting_id != null);
	if (filterable.length === 0) return null;

	// The unfiltered state is named for what it shows rather than for the
	// absence of a filter: it heads the section, so it reads as a title.
	const options = [
		{ value: '', label: 'Goals Overview' },
		...filterable.map((goal) => ({
			value: String(goal.goal_setting_id),
			label: goal.name,
		})),
	];

	return (
		<Select
			className={styles.select}
			variant='primary'
			label='Filter the calendar by goal'
			value={value ?? ''}
			onChange={(next) => onChange(next || null)}
			options={options}
		/>
	);
};

export default GoalFilter;
